import { InjectionToken } from '@angular/core';

export type BooxStorageToken = {
    salt: string;
    domain: string;
    [key: string]: any;
}

export const BOOX_STORAGE = new InjectionToken<BooxStorageToken>('(lib-boox) BOOX_STORAGE', {
    providedIn : 'root', factory: () => ({salt: 'boox', domain: 'boox'})
});